import { createStyles } from "@mantine/core";
import { colors } from "theme";
import { sizeVariants } from "./sizeVariants";
import { SizeVariant } from "./types";

export const useTextStyles = (variant: SizeVariant) =>
  createStyles(() => ({
    text: {
      ...sizeVariants[variant],
      color: colors.grey[90],
    },
  }))();
